import HTML from '../html'
import PropertyLister from './Finder/property-lister/controller'
import remoteServer from './Finder/remote-server'

export default class ObjektList extends PropertyLister {

    constructor(rootBlock) {
        super(rootBlock)
        this.root = $(rootBlock)
        this.contentRoot = this.root.find('.objektlista__content')
        this.listRoot = this.root.find('.objektlista__content__list')
        this.projektID = this.root.data('property-projekt-id')
        this.projektAccommodation = this.root.data('property-projekt-accommodation')

        this.remoteServer = remoteServer()

        this.remoteServer.request(data => {
            this.manage(data).render()
        })

        const fee = this.objektProps.find(obj => obj.name === 'Avgift');

        if (this.projektAccommodation === "Hyresrätt") {
            this.objektProps.splice(4, 1);

            if (fee) {
                fee.name = 'Hyra';
            }
        }
    }

    manage(data) {
        let projekt = data.projekts.filter(projekt => projekt.wpid === this.projektID)
        if (projekt.length) {
            let objekts = data.objekts.filter(objekt => {
                return projekt[0].objekts.includes(objekt.guid)
            })
            if (!objekts.length) {
                $(this.root).append(HTML('h3').classes('subtle').content('Ingenting att visa').render())
                $(this.contentRoot).hide()
                return this
            }
            this.props.objekts = objekts
        }
        return this
    }

    clearObjekts() {
        this.listRoot.empty()
        return this
    }

    fillObjekts() {
        this.sortProps()
        if (this.props.objekts) {
            this.listRoot.append(
                this.view.objektsList(this.props.objekts),
            )
        }
        return this
    }

    render() {
        if (!this.props.objekts.length) {
            return this
        }
        this.sortProps()
        this.clearObjekts().fillObjekts()
        return this
    }

    updateProps() {
        this.render()
        return this;
    }
}
